/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  ADD_TAT,
  LOAD_QC_RECHECK,
  UPDATE_PROCESS
  
} from "./constants"

import {
  loadPostQcRecheck,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadPostQcRecheckSuccess,
  loadPostQcRecheckError,
  addTatSuccess,
  addTatError,
  updateProcessSuccess,
  updateProcessError
 
  
} from "./actions"

import {
  loadRecordsMetaData,
  loadPostQcRecheckApi,
  addTatAPI,
  updateProcessAPI

  
} from "./remotes"

function* loadPostQcRecheckSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_QC_RECHECK),
    })

    const { explicitLoad } = load
    const { searchFilter } = explicitLoad || {}
    yield put(loadPostQcRecheck(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPostQcRecheckApi, searchFilter)
        if (result) {
          yield put(loadPostQcRecheckSuccess(result.data))
          console.log(result.data, "result")
        } else {
          yield put(loadPostQcRecheckSuccess([]))
          yield put(loadPostQcRecheckError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadPostQcRecheckSuccess([]))
        yield put(
          loadPostQcRecheckError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}



function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
     

    
      const company = yield call(
        loadRecordsMetaData,
        "company",
        "post"
      )
      const branch = yield call(
        loadRecordsMetaData,
        "branch",
        "post"
      )
      const event = yield call(
        loadRecordsMetaData,
        "event",
        "post"
      )
      const product =  yield call(loadRecordsMetaData, "product", "post")

      const employee = yield call ( loadRecordsMetaData,
        "employee_dropdown_list",
        "post")
      const processStatus = yield call(loadRecordsMetaData, "process_status", "post")
      let permissionMetaData = {
        companyOptions:
        (company &&
          company.data &&
          company.data.length > 0 &&
          company.data
            .filter((_) => _.status === 1)
            .map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
        (company &&
          company.length > 0 &&
          company.map((c) =>
            Object.assign({}, { label: c.name, value: c._id })
          )) ||
        [],
        productOptions:
        (product &&
          product.data &&
          product.data.length > 0 &&
          product.data
            .filter((_) => _.status === 1)
            .map((c) =>
              Object.assign(
                {},
                {
                  label: c.productName,
                  value: c._id,
                  productCode: c.productCode,
                }
              )
            )) ||
        [],

      branchOptions:
        (branch &&
          branch.data &&
          branch.data.length > 0 &&
          branch.data
            .filter((_) => _.status === 1)
            .map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
        (branch &&
          branch.length > 0 &&
          branch.map((c) =>
            Object.assign(
              {},
              { label: c.name, value: c._id, companyId: c.companyId }
            )
          )) ||
        [],
        eventOptions:
        (event &&
          event.data &&
          event.data.length > 0 &&
          event.data
            .filter((_) => _.status === 1)
            .map((c) =>
              Object.assign(
                {},
                {
                  label: c.eventName,
                  value: c._id,
                  eventCode: c.eventCode,
                  //  companyId: c.companyId
                }
              )
            )) ||
        [],

        employeeOptions:
        (employee &&
          employee.data &&
          employee.data.length > 0 &&
          employee.data
           
            .map((c) =>
              Object.assign(
                {},
                {
                  label:c.empCode.concat(" - ", c.name),
                  value: c._id,
                  
                }
              )
            )) ||
        [],
        processStatusOptions:
        (processStatus &&
          processStatus.data &&
          processStatus.data.length > 0 &&
          processStatus.data
            .filter((_) => _.status === 1)
            .map((p) =>
              Object.assign(
                {},
                {
                  label: p.processStatus,
                  value: p.processStatusId,
                  processStatusId: p.processStatusId,
                  colorCode: p.colorCode,
                }
              )
            )) ||
        [],
      }
     
      yield put(loadRecordsMetaDataSuccess(permissionMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* addTatSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_TAT),
    })
    const { tat_details } = add || {}
    if (add) {
      try {
        yield call(addTatAPI, tat_details)
        yield put(
          addTatSuccess(
            tat_details,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          addTatError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}


function* updateProcessSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(UPDATE_PROCESS),
    })
    const { submitStatus } = add || {}
    if (add) {
      try {
        yield call(updateProcessAPI,submitStatus)
        yield put(
          updateProcessSuccess(
            submitStatus,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          updateProcessError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadPostQcRecheckSaga(),
    
    loadRecordsMetaDataSaga(),

    addTatSaga(),

    updateProcessSaga()
  ])
}
